// extracted by mini-css-extract-plugin
export default {"title":"Io1sYA","faqMobileRoot":"aBsZIr","mobileTitle":"JjMQyJ","mobileSubtitle":"GfG_lL"};